<template>
  <div class="flex flex-col">
    <div v-for="(applicant, index) in applicants" :key="index" class="flex mb-4 border-b pb-4">
      <icon name="user" class="w-3 h-3 mr-3 text-tertiary" :center="false" />
      <div class="w-full flex flex-col">
        <div class="flex mb-1">
          <div class="text-xs border-r pr-3">{{ applicant.applicant_name }}</div>
          <div class="text-xs pl-3">{{ applicant.applicant_phone }}</div>
        </div>
        <span class="text-xs mb-3">{{ applicant.applicant_email }}</span>
        <span class="flex flex-col text-xs">
          <span class="flex items-center">
            <a :href="applicant.applicant_url" target="_blank" class="text-tertiary">{{ truncate(applicant.applicant_url, 30) }}</a>
            <copy-link :link="applicant.applicant_url" class="w-full text-center cursor-pointer text-xxs">Copy Link</copy-link>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import CopyLink from '@/components/CopyLink'
import { truncate } from '@/helpers'

export default {
  name: 'ApplicantList',

  components: {
    CopyLink
  },

  methods: {
    truncate
  },

  props: ['applicants']
}
</script>
